import axios from "axios";

// Prefer the browser's own origin when deployed (backend is served same-origin
// behind /api). Falls back to REACT_APP_BACKEND_URL for dev/preview. This keeps
// the site working on every hostname (www + apex + emergent.host).
const envBase = process.env.REACT_APP_BACKEND_URL;
function resolveBase() {
  try {
    if (
      typeof window !== "undefined" &&
      window.location.protocol === "https:" &&
      envBase &&
      new URL(envBase).host !== window.location.host
    ) {
      return window.location.origin;
    }
  } catch (e) {
    console.warn("Could not parse backend URL env, using window origin fallback:", e);
  }
  return envBase;
}
const BACKEND_URL = resolveBase();
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (detail == null) return err?.message || "Something went wrong.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  }
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function photoUrl(jobId) {
  return `${API_BASE}/jobs/${jobId}/photo`;
}

export function jobPhotoSrc(job) {
  return job?.photo_url?.startsWith("http") ? job.photo_url : photoUrl(job.id);
}

export function assetUrl(path) {
  if (!path) return "";
  return path.startsWith("http") ? path : `${BACKEND_URL}${path}`;
}
